export enum ReportingTabType {
    Overview = 0,
    DealPerformance = 1,
}